import React from 'react';
import { install } from 'resize-observer';
import { createRoot } from 'react-dom/client';
import 'core-js/features/array/at';
import 'core-js/features/array/to-sorted';
import 'core-js/features/array/to-reversed';
import 'core-js/features/promise/all-settled';
import 'core-js/features/object/has-own';
import 'core-js/features/array-buffer/transfer-to-fixed-length';

import './initSentry';
import App from './App';
import './styles/index.css';
import './polyfill/google-translate';
import { disableBrowserTranslation } from './utils/global';

// Opt out of in-page browser translation (Chrome iOS), which mutates the DOM
// under React and can trigger a stack-overflow crash. The app is already i18n.
disableBrowserTranslation();

// Create application container element
const container = document.createElement('div');
container.id = 'root';
document.body.appendChild(container);

// Install ResizeObserver polyfill for old version of Safari
if (!window.ResizeObserver) {
  install();
}

// Run the application
const root = createRoot(container);
root.render(<App />);
